<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="8" style="text-align: left">
          <v-btn
            text
            x-small
            @click="
              filterData.status = '';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="info"
                :content="totalIdeas.toString()"
                style="font-size: 10px"
              >
                <b v-if="filterData.status == ''" style="color: #7cb342">All</b>
                <b v-else>All</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              filterData.status = 'Need Approval';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="needApprovalIdeas.toString()"
                style="font-size: 10px"
              >
                <b
                  v-if="filterData.status == 'Need Approval'"
                  style="color: #7cb342"
                  >Need Approval</b
                >
                <b v-else>Need Approval</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              filterData.status = 'Making Art';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="makingArtIdeas.toString()"
                style="font-size: 10px"
              >
                <b
                  v-if="filterData.status == 'Making Art'"
                  style="color: #7cb342"
                  >Making Art</b
                >
                <b v-else>Making Art</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              filterData.status = 'Uploading';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="orange"
                :content="uploadingIdeas.toString()"
                style="font-size: 10px"
              >
                <b
                  v-if="filterData.status == 'Uploading'"
                  style="color: #7cb342"
                  >Uploading</b
                >
                <b v-else>Uploading</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              filterData.status = 'Completed';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="#00ACC1"
                :content="completedIdeas.toString()"
                style="font-size: 10px"
              >
                <b
                  v-if="filterData.status == 'Completed'"
                  style="color: #7cb342"
                  >Completed</b
                >
                <b v-else>Completed</b>
              </v-badge>
            </v-tab>
          </v-btn>

          <v-btn
            text
            x-small
            @click="
              filterData.status = 'Canceled';
              search();
            "
          >
            <v-tab>
              <v-badge
                color="success"
                :content="canceledIdeas.toString()"
                style="font-size: 10px"
              >
                <b v-if="filterData.status == 'Canceled'" style="color: #7cb342"
                  >Canceled</b
                >
                <b v-else>Canceled</b>
              </v-badge>
            </v-tab>
          </v-btn>
        </v-col>

        <v-col cols="4" style="text-align: right">
          <v-btn
            small
            color="success"
            dark
            @click="dialogCreate = !dialogCreate"
            v-if="roles.create_idea"
            >New Idea</v-btn
          >
          <v-btn small color="success" v-else disabled>New Idea</v-btn>
          &nbsp;
          <v-btn small @click.stop="drawer = !drawer" outlined color="indigo"
            >Filter Data</v-btn
          >
        </v-col>
      </v-row>
    </v-col>

    <v-alert
      v-model="alert"
      close-text="Close Alert"
      dense
      text
      type="success"
      dismissible
      style="text-align: left"
    >
      {{ informText }}
    </v-alert>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="listIdeasData"
      :options.sync="pagination"
      :server-items-length="marchingIdeas"
      item-key="_id"
      show-select
      class="elevation-1"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, 100, 200, 500, 1000],
      }"
    >
      <template v-slot:item.thumbnail="{ item }">
        <img :src="item.banner_link" style="width: 100px" />
      </template>

      <template v-slot:item.priority="{ item }">
        <template v-if="item.priority == 'Normal'">
          <b>{{ item.priority }}</b>
        </template>
        <template v-else-if="item.priority == 'High'">
          <v-chip color="orange" dark
            ><b>{{ item.priority }}</b></v-chip
          >
        </template>
        <template v-else-if="item.priority == 'Urgent'">
          <v-chip color="red" dark
            ><b>{{ item.priority }}</b></v-chip
          >
        </template>
      </template>

      <template v-slot:item.product_info="{ item }">
        <td style="font-size: 12px">
          <div><b>Idea ID:</b> {{ item._id }}</div>
          <div><b>Product Code:</b>{{ item.product_code }}</div>
          <div><b>Product Title:</b> {{ item.product_title }}</div>
        </td>
      </template>
      <template v-slot:item.users="{ item }">
        <template v-if="item.idea != ''">{{ item.idea }}</template
        ><template v-else>None</template> -
        <template v-if="item.artist != ''">{{ item.artist }}</template
        ><template v-else>None</template> -
        <template v-if="item.scaler != ''">{{ item.scaler }}</template
        ><template v-else>None</template>
        <template v-if="item.uploader != '' && item.uploader">
          - {{ item.uploader }}</template
        ><template v-else> - None</template>
      </template>
      <template v-slot:item.note="{ item }">
        <td style="font-size: 12px">{{ item.note }}</td>
      </template>
      <template v-slot:item.created_date="{ item }">
        <td v-if="!item.urgent">
          <div>
            <b>{{ item.createdDateFromNow }}</b>
          </div>
          {{ item.created_date }}
        </td>
        <td v-else style="color: red">
          <div>
            <b>{{ item.createdDateFromNow }}</b>
          </div>
          {{ item.created_date }}
        </td>
      </template>
      <template v-slot:item.status="{ item }">
        <td>
          {{ item.status }}
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          x-small
          @click="
            selectedIdea = item;
            dialogEdit = !dialogEdit;
          "
          v-if="roles.read_idea"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <v-btn color="primary" x-small v-else disabled>
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        &nbsp;
        <v-btn
          color="purple"
          @click="duplicateItem(item)"
          x-small
          v-if="roles.read_idea"
          dark
        >
          <v-icon small> mdi-content-copy </v-icon>
        </v-btn>
        <v-btn color="purple" x-small v-else disabled dark>
          <v-icon small> mdi-content-copy </v-icon>
        </v-btn>
        &nbsp;
        <v-btn
          color="orange"
          @click="deleteItem(item)"
          x-small
          v-if="roles.update_idea && item.status != 'Completed'"
          dark
        >
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
        <v-btn color="orange" x-small v-else disabled>
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list nav dense class="menu-scroll">
        <v-list-item>
          <v-select
            :items="listSearchAll"
            :item-text="(obj) => obj.value"
            :item-value="(obj) => obj.id"
            label="Search All"
            dense
            outlined
            v-model="filterData.searchBy"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-text-field
            label="Search here"
            outlined
            v-model="filterData.searchWord"
            @keyup.enter="search"
            v-if="filterData.searchBy != ''"
            dense
          ></v-text-field>
          <v-text-field
            label="Search here"
            outlined
            v-else
            disabled=""
            dense
          ></v-text-field>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listIdea"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Idea"
            dense
            outlined
            multiple
            v-model="filterData.idea"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listDesigner"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Artist"
            dense
            outlined
            multiple
            v-model="filterData.artist"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listDesigner"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Scaler"
            dense
            outlined
            multiple
            v-model="filterData.scaler"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listUploader"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Uploader"
            dense
            outlined
            multiple
            v-model="filterData.uploader"
          ></v-select>
        </v-list-item>

        <v-list-item>
          <v-select
            :items="listProductType"
            label="Product Type"
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            dense
            outlined
            v-model="filterData.product_type_id"
          ></v-select>
        </v-list-item>

        <v-col cols="12">
          <v-btn
            @click="search"
            small
            outlined
            color="indigo"
            style="float: left"
            >Apply</v-btn
          >
          <v-btn
            @click="reset"
            small
            outlined
            color="indigo"
            style="float: right"
            >Reset</v-btn
          >
        </v-col>
      </v-list>
    </v-navigation-drawer>

    <template>
      <BaseDialog :active.sync="dialogCreate" dialog_name="Create New Idea">
        <Create
          :userId="userId"
          :listIdea="listIdea"
          :listDesigner="listDesigner"
          :listUploader="listUploader"
          :listProductType="listProductType"
        />
      </BaseDialog>
    </template>

    <template>
      <BaseDialog :active.sync="dialogEdit" dialog_name="Edit Idea">
        <Edit
          :userId="userId"
          :listIdea="listIdea"
          :listDesigner="listDesigner"
          :listUploader="listUploader"
          :listProductType="listProductType"
          :ideaData="selectedIdea"
        />
      </BaseDialog>
    </template>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment-timezone";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
import BaseDialog from "../Common/c-base-dialog";
//import Create from "./c-dialog-idea-create";
import Create from "./c-dialog-idea-create";
import Edit from "./c-dialog-idea-edit";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Tags",

  components: {
    BaseDialog,
    Create,
    Edit,
  },

  data: () => ({
    roles: [],

    drawer: false,
    alert: false,
    informText: "",
    loading: false,
    dialogCreate: false,
    dialogEdit: false,
    selected: [],
    listDesigner: [],
    listIdea: [],
    listUploader: [],
    listProductType: [],
    listStatus: [],
    selectedIdea: [],

    userId: "",

    searchInput: null,

    listSearchAll: [
      { id: "product_title", value: "Product Title" },
      { id: "product_code", value: "Product Code" },
      { id: "idea_id", value: "Idea ID" },
    ],

    headers: [
      //{ text: 'TaskID', value: '_id',width: '7%' },
      { text: "Image", value: "thumbnail", align: "start" },
      { text: "Product Info", value: "product_info" },
      { text: "Idea-Artist-Scaler-Uploader", value: "users" },
      { text: "Product Type", value: "product_type_name" },
      { text: "Approval", value: "approval" },
      { text: "Priority", value: "priority" },
      { text: "Created Date", value: "created_date" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: false,
      groupDesc: false,
      multiSort: false,
      mustSort: false,
    },

    filterData: {
      searchBy: "",
      searchWord: "",
      product_type_id: "",
      status: "",
      idea: [],
      artist: [],
      scaler: [],
      uploader: [],
    },

    listIdeasData: [],
    marchingIdeas: 0,
    totalIdeas: 0,
    makingArtIdeas: 0,
    needApprovalIdeas: 0,
    uploadingIdeas: 0,
    completedIdeas: 0,
    canceledIdeas: 0,
  }),

  watch: {
    pagination: {
      handler() {
        let queryParams = this.getParams();

        this.$router
          .push({ path: "ideas", query: queryParams })
          .catch((err) => {
            var error = err.toString();
            if (!error.includes("redundant navigation")) {
              throw err;
            }
          });
        console.log("pagination");
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {
    this.$root.$refs.idea = this;
  },

  computed: {},

  methods: {
    turnOffDialog() {
      this.dialogCreate = false;
      this.dialogEdit = false;

      this.getDataFromApi();
    },

    clearSelected() {
      this.selected = [];
    },

    showAlert(type, data1, data2) {
      this.alert = true;
      if (type == "import") {
        this.dialogImport = false;
        this.informText =
          "We're currently importing your orders into database. This could take somes minutes to complete. If you'd like, you can close this notification and continue to working.";
      } else if (type == "export") {
        this.dialogExport = false;
        this.informText =
          "We're currently processing your data. System will send a file to your email when completed. If you'd like, you can close this notification and continue to working.";
      } else {
        this.dialogAssign = false;
        this.getDataFromApi();
        this.informText =
          data2.length +
          " selected task(s) have been assigned to '" +
          data1 +
          "'";
        this.selected = [];
      }
    },

    getParams() {
      let queryParams = {
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
        sortBy: this.pagination.sortBy[0],
        sortDesc: this.pagination.sortDesc[0],
      };

      if (this.filterData.searchBy != "" && this.filterData.searchWord != "") {
        queryParams["searchBy"] = this.filterData.searchBy;
        queryParams["searchWord"] = this.filterData.searchWord;
      }

      if (this.filterData.product_type_id != "") {
        queryParams["product_type_id"] = this.filterData.product_type_id;
      }

      if (this.filterData.status != "") {
        queryParams["status"] = this.filterData.status;
      }

      if (this.filterData.artist != "") {
        queryParams["artists"] = this.filterData.artist.join(",");
      }

      if (this.filterData.idea != "") {
        queryParams["idea_owners"] = this.filterData.idea.join(",");
      }

      if (this.filterData.scaler != "") {
        queryParams["scalers"] = this.filterData.scaler.join(",");
      }

      if (this.filterData.uploader != "") {
        queryParams["uploaders"] = this.filterData.uploader.join(",");
      }

      return queryParams;
    },

    async getDataFromApi() {
      this.loading = true;

      let queryParams = this.getParams();

      var currentSession = await this.$root.$refs.App.currentSession(
        "idea-loadData"
      );
      if (currentSession.accessToken) {
        this.userId = currentSession.username;
        await axios
          .get(window.domain + "ideas", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            console.log(response);
            this.listIdeasData = response.data.data.ideas;
            this.listDesigner = response.data.data.designers;
            this.listIdea = response.data.data.idea_users;
            this.listUploader = response.data.data.uploaders;
            this.listProductType = response.data.data.product_type;
            this.listStatus = response.data.data.statuses;

            this.marchingIdeas = response.data.data.marchingIdeas || 0;
            this.totalIdeas = response.data.data.totalIdeas || "0";
            this.makingArtIdeas = response.data.data.makingArtIdeas || "0";
            this.needApprovalIdeas =
              response.data.data.needApprovalIdeas || "0";
            this.uploadingIdeas = response.data.data.uploadingIdeas || "0";
            this.completedIdeas = response.data.data.completedIdeas || "0";
            this.canceledIdeas = response.data.data.canceledIdeas || "0";
            //this.canceledTasks = response.data.data.canceledTasks || "0";

            //var today = moment(new Date()).tz("Asia/Ho_Chi_Minh");

            for (const i of this.listIdeasData) {
              i.created_date = moment(i.created_date)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MMM/YYYY - HH:mm");

              for (const j of this.listProductType) {
                if (i.product_type_id == j._id) {
                  i["product_type_name"] = j.product_type;
                }
              }
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } else {
        console.log(
          "currentSession ideas-loadData-undefined: ",
          currentSession
        );
      }
    },

    search() {
      let queryParams = this.getParams();
      queryParams.page = 1;
      this.pagination.page = 1;
      //this.selected = []

      this.$router.push({ path: "ideas", query: queryParams }).catch((err) => {
        var str = err.toString();
        if (str.includes("current location")) {
          err = "";
        }
      });
      console.log("search");
      this.getDataFromApi();
    },

    reset() {
      (this.filterData = {
        searchBy: "",
        searchWord: "",
        product_type_id: "",
        status: "",
        idea: "",
        artist: "",
        scaler: "",
        uploader: "",
      }),
        console.log("search");
      //this.getDataFromApi()
    },

    clear() {
      this.selected = [];
    },

    async duplicateItem(item) {
      var r = confirm("Are you sure to duplicate this idea?");
      if (r == true) {
        var itemData = {
          idea: item.idea,
          artist: item.artist,
          scaler: item.scaler,
          uploader: item.uploader,
          product_title: item.product_title,
          product_type_id: item.product_type_id,
          idea_description: item.idea_description,
          banner_link: item.banner_link,
          resource_link: item.resource_link,
          priority: item.priority,
          status: item.status,
          approval: item.approval,
          idea_images: item.idea_images,
        };

        console.log("itemData: ", itemData);

        var currentSession = await this.$root.$refs.App.currentSession(
          "duplicate-idea-sendAPI"
        );

        if (currentSession.accessToken) {
          await fetch(window.domain + "ideas", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(itemData),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Create Idea response: ", data);
              if (data.error_message == "") {
                this.getDataFromApi();
              } else {
                console.log("error: ", data.error_message);
                alert(data.error_message);
              }
            })
            .catch((error) => console.log("Err: ", error));
        } else {
          console.log(
            "currentSession duplicate-idea-undefined: ",
            currentSession
          );
        }
      }
    },

    async deleteItem(item) {
      var r = confirm("Are you sure to delete this idea?");
      if (r == true) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "delete-idea-sendAPI"
        );

        if (currentSession.accessToken) {
          await fetch(window.domain + "ideas/" + item._id, {
            method: "DELETE",
            headers: { Authorization: currentSession.accessToken },
            //body: JSON.stringify(itemData),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Delete Idea response: ", data);
              if (data.error_message == "") {
                this.getDataFromApi();
              } else {
                console.log("error: ", data.error_message);
                alert(data.error_message);
              }
            })
            .catch((error) => console.log("Err: ", error));
        } else {
          console.log("currentSession delete_idea-undefined: ", currentSession);
        }
      }
    },

    check() {
      console.log(this.editedItem);
    },

    validation() {
      if (this.editedItem.tag_name != "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    if (this.$route.query != "") {
      //console.log("true")
      if (this.$route.query.page)
        this.pagination.page = parseInt(this.$route.query.page);
      if (this.$route.query.itemsPerPage)
        this.pagination.itemsPerPage = parseInt(this.$route.query.itemsPerPage);
      if (this.$route.query.sortBy)
        this.pagination.sortBy[0] = this.$route.query.sortBy;
      if (this.$route.query.sortDesc)
        this.pagination.sortDesc[0] = this.$route.query.sortDesc;

      if (this.$route.query.searchBy)
        this.filterData.searchBy = this.$route.query.searchBy;
      if (this.$route.query.searchWord)
        this.filterData.searchWord = this.$route.query.searchWord;

      if (this.$route.query.status) {
        this.filterData.status = this.$route.query.status;
      }

      if (this.$route.query.product_type_id) {
        this.filterData.product_type_id = this.$route.query.product_type_id;
      }

      if (this.$route.query.idea_owners) {
        this.filterData.idea = this.$route.query.idea;
      }

      if (this.$route.query.artists) {
        this.filterData.artist = this.$route.query.artist;
      }

      if (this.$route.query.scalers) {
        this.filterData.scaler = this.$route.query.scaler;
      }

      if (this.$route.query.uploaders) {
        this.filterData.uploader = this.$route.query.uploader;
      }
    }

    this.roles = await this.$cookies.get("idea");
    if (this.roles.list_ideas) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

